import { decodeJwt } from 'jose';
import moize from 'moize';
import { APP_ENV } from '@/env';
import { authApi } from './apis/auth';
import { postRefreshAccessToken } from '@/apis/core/postRefreshAccessToken';

// OAuth login host varies by app environment, including staging.
const OAUTH_LOGIN_HOST = {
  production: 'account.realworld.to',
  development: 'account-test.realworld.to',
  staging: 'account-staging.realworld.to'
}[APP_ENV];

export const OAUTH_LOGIN_URI = `https://${OAUTH_LOGIN_HOST}/auth/signin?redirectUrl=${window.location.href}&referrer=studio`;

// export function goToLoginPageWithCurrentUriRedirect() {
//   window.location.href = `${OAUTH_LOGIN_URI}${encodeURIComponent(
//     `?redirect=${window.location.pathname}${window.location.search}`
//   )}`;
// }
// NOTE: 로그인이 되어있어야 하는 페이지 주소를 복사해서 다른 웹에서 접속했을 때 다른 로그인 페이지가 나오는 이슈 해결을 위한 작업
export function goToLoginPageWithCurrentUriRedirect() {
  const redirectUrl = `${window.location.origin}/auth/login?redirect=${encodeURIComponent(
    window.location.pathname + window.location.search
  )}`;
  window.location.href = `https://${OAUTH_LOGIN_HOST}/auth/signin?redirectUrl=${encodeURIComponent(
    redirectUrl
  )}&referrer=studio`;
}

async function getAccessTokenOriginal() {
  const localStorageAccessToken = localStorage.getItem('accessToken');
  // SSO 세션이 있을 수 있으므로 시도
  try {
    if (localStorageAccessToken) {
      const expiresAt = parseJwtExpToISOString(localStorageAccessToken);

      if (Date.parse(expiresAt) - 1000 * 60 < Date.now()) {
        const refreshToken = localStorage.getItem('refreshToken');

        if (!refreshToken) throw Error();

        const refreshed = await postRefreshAccessToken({
          accessToken: localStorageAccessToken,
          refreshToken
        });

        localStorage.setItem('accessToken', refreshed.token);
        localStorage.setItem('refreshToken', refreshed.refreshToken);
        localStorage.setItem('expiresAt', parseJwtExpToISOString(refreshed.token));

        return refreshed.token;
      }

      return localStorageAccessToken;
    }
    throw new Error('No token');
  } catch (e) {
    console.error(e);
    try {
      const {
        data: { token: newAccessToken, refreshToken: newRefreshToken }
      } = await authApi.apiAuthReissueGet();

      if (newAccessToken && newRefreshToken) {
        localStorage.setItem('accessToken', newAccessToken);
        localStorage.setItem('refreshToken', newRefreshToken);
        localStorage.setItem('expiresAt', parseJwtExpToISOString(newAccessToken));
      } else {
        throw new Error('No token or refreshToken');
      }

      return newAccessToken;
    } catch (e) {
      console.error(e);
    }
  }

  return null;
}
export const getAccessToken = moize(getAccessTokenOriginal, {
  maxAge: 5000
});

export function parseJwtExpToISOString(accessToken: string) {
  const { exp } = decodeJwt(accessToken);
  if (!exp) throw Error('JWT exp is undefined. except type is string');

  return new Date(exp * 1000).toISOString();
}
